import React from 'react';
import classnames from 'classnames';

interface CollegeLogoProps {
  logo?: string | null;
  className?: string;
  size?: string | number;
}

const CollegeLogo = ({logo, className, size = 44}: CollegeLogoProps) => {
  if (!logo) return null;

  return (
    <img
      src={logo}
      className={classnames('shared-college-logo', className)}
      style={{height: size, width: size}}
      alt=""
      aria-hidden="true"
    />
  );
};

export default CollegeLogo;
